import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const StoreBookAppointmentCTA = (_param)=> {
    var { className , labels , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "onClick"
    ]);
    return React__default.createElement(Button, swcHelpers.extends({}, rest, {
        className: classnames('store-book-appointment-cta-stores-v2', className),
        variant: "solid",
        onClick: onClick
    }), /*#__PURE__*/ React__default.createElement("span", {
        className: "store-book-appointment-cta-stores-v2__icon"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "calendar"
    })), labels.caption);
};
var StoreBookAppointmentCTA$1 = StoreBookAppointmentCTA;

export { StoreBookAppointmentCTA$1 as default };
//# sourceMappingURL=StoreBookAppointmentCTA.js.map
